/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Modal, Input } from 'antd';
import { ExclamationCircleFilled, DownloadOutlined } from '@ant-design/icons';
import { NotificationAlert, Table } from '../../../components';

//import { exportToExcel } from './helper';
import { useEffect, useRef, useState } from 'react';
import QuestionIcon from '../../../assets/question-circle.svg';

import dayjs from 'dayjs';
import {
  annualReviewStatuses,
  quarterReviewStatuses,
  statusColors,
  Statuses,
  statusesLabel,
} from '../../../helper';

import { SearchProps } from 'antd/es/input';
import {
  AnnualReviewCycle,
  AnnualReviewCycleDetails,
  AnnualReviewUsers,
} from '../../../types/AnnualReview';
import {
  getAllAnnualReviewCycles,
  getAllAnnualReviewCycleUsers,
  getAnnualCycleById,
  updateAnnualReviewCycle,
} from '../../../services/annualServices';
import { useAtomValue } from 'jotai';
import { userAtom } from '../../../store/atom';
import { AnnualCycleUsersColumns } from './Columns';
import { getAnnualFeedbackReportHr } from '../../../services/annualFeedbackService';
import { exportToExcel } from './helper';
import { useLocation } from 'react-router-dom';

const { Search } = Input;
let searchtimer: ReturnType<typeof setTimeout>;

const AnnualCycleEmployees = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [exportLoading, setExportLoading] = useState(false);
  const [annualReviewData, setAnnualReviewData] = useState({
    'Start Date': '-',
    'End Date': '-',
    'Mentor Deadline': '-',
    Name: '',
  });
  const myRef = useRef<any>();
  const [allAnnualReviewData, setAllAnnualReviewData] =
    useState<AnnualReviewCycle>();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<AnnualReviewUsers[]>([]);
  const [fetchLoading, setFetchLoading] = useState(true);
  const [disableInit, setDisableInit] = useState(true);
  const [filtered, setFiltered] = useState<AnnualReviewUsers[]>([]);
  const { cycleId } = useAtomValue(userAtom);
  const { selectedId } = useLocation().state;

  // fetch quarter details
  const fetchAnnualCycleReviewData = async () => {
    const { data, error } = await getAnnualCycleById(selectedId, 'hr');
    if (error) return myRef.current?.call('error', error?.message);
    setAllAnnualReviewData(data);
    const status = annualReviewStatuses[data?.status || 0];
    setAnnualReviewData({
      'Start Date': dayjs(data?.startDate).format('MMM DD YYYY'),
      'End Date': dayjs(data?.endDate).format('MMM DD YYYY'),
      'Mentor Deadline': dayjs(data?.mentorDeadline).format('MMM DD YYYY'),
      [status]: data?.progress,
      Name: data?.name || '',
    });
  };

  // fetch quarter users
  const fetchAnnualCycleUsers = async () => {
    setFetchLoading(true);
    const { data, error } = await getAllAnnualReviewCycleUsers(cycleId, 'hr');
    setFetchLoading(false);
    if (error) return myRef.current?.call('error', error?.message);
    if (data) {
      setData(data);
      setFiltered(data);
    }
  };

  // get all quarters and find any active quarter there for enable current quarter initiate option
  const findActiveAnnualCycle = (annualCycles: AnnualReviewCycle[]) => {
    const filter = annualCycles;
    if (filter.length > 0) {
      let disable = false;
      filter.map((item) => {
        const status = quarterReviewStatuses[item.status];
        if (status === Statuses.InProgress) disable = true;
      });
      setDisableInit(disable);
    } else {
      setDisableInit(false);
    }
  };
  const getAllQuarter = async () => {
    setDisableInit(true);
    const { data, error } = await getAllAnnualReviewCycles('hr');
    if (error) return myRef.current?.call('error', error?.message);
    if (error) return;
    findActiveAnnualCycle(data);
  };

  useEffect(() => {
    fetchAnnualCycleReviewData();
    fetchAnnualCycleUsers();
  }, []);

  useEffect(() => {
    if (allAnnualReviewData?.year) getAllQuarter();
  }, [allAnnualReviewData?.year]);

  // update quarter review
  const updateAnnualReview = async (status: number) => {
    setLoading(true);
    const { error } = await updateAnnualReviewCycle(cycleId, {
      Name: allAnnualReviewData?.name,
      StartDate: allAnnualReviewData?.startDate,
      EndDate: allAnnualReviewData?.endDate,
      MentorDeadline: allAnnualReviewData?.mentorDeadline,
      Year: allAnnualReviewData?.year,
      Status: status,
      ParPointsScoreList: [],
      ClientUtilizationScoreList: [],
    } as AnnualReviewCycleDetails);
    setLoading(false);
    if (error) return myRef.current?.call('error', error?.message);
    fetchAnnualCycleReviewData();
    return true;
  };

  const handleInit = () => {
    modal.confirm({
      title: 'Are you sure you want to initiate this review cycle?',
      icon: <img src={QuestionIcon} alt="" width={28} className="mr-3" />,
      okText: 'Yes',
      cancelText: 'Cancel',
      onOk() {
        return updateAnnualReview(1);
      },
    });
  };

  const handleClose = () => {
    modal.confirm({
      title: 'Are you sure you want to close this review cycle?',
      icon: <ExclamationCircleFilled />,
      okText: 'Yes',
      cancelText: 'Cancel',
      onOk() {
        return updateAnnualReview(3);
      },
    });
  };

  const getReportData = async (cycleId: string) => {
    const response = await getAnnualFeedbackReportHr(cycleId);
    if (response.error)
      return myRef.current?.call('error', response.error?.message);
    if (response.data) return response.data;
    return data;
  };

  const handleExportData = async () => {
    setExportLoading(true);
    const reportData = await getReportData(cycleId);
    if (reportData) {
      const statusEntry = Object.entries(annualReviewData).find(([key]) =>
        statusesLabel[key]
      );
      const progress = statusEntry
        ? `${statusesLabel[statusEntry[0]]} - ${statusEntry[1]}%`
        : reportData.progress;

      const headers = {
        startDate: reportData.startDate,
        endDate: reportData.endDate,
        mentorDeadline: reportData.mentorDeadline,
        progress: progress,
      };
      exportToExcel(
        headers,
        reportData,
        `All Employees Annual Feedback Report - ${allAnnualReviewData?.year}`
      );
    }
    setExportLoading(false);
  };

  const filterData = (value: string) =>
    data?.filter(
      (item) =>
        item?.name?.toLocaleLowerCase().includes(value) ||
        item?.designation?.toLocaleLowerCase().includes(value) ||
        item?.tier?.toString()?.toLocaleLowerCase().includes(value)
    );

  const onSearch: SearchProps['onSearch'] = (value) => {
    setLoading(true);
    value = value?.toLocaleLowerCase();
    const filter = filterData(value);
    setFiltered(filter);
    setLoading(false);
  };

  const handleChange = (value: string) => {
    if (value !== '') {
      clearTimeout(searchtimer);
      searchtimer = setTimeout(() => {
        value = value?.toLocaleLowerCase();
        const filter = filterData(value);
        setFiltered(filter);
      }, 600);
    } else {
      clearTimeout(searchtimer);
      setFiltered(data);
    }
  };

  return (
    <div className="flex flex-col gap-y-[10px]">
      <div className="p-[10px] mb-[-10px]">
        <div className="text-[20px] font-[500]">{annualReviewData?.Name}</div>
        <div className="opacity-45">
          Initiate/close an annual review cycle and export details of this
          annual review cycle to excel.
        </div>
      </div>

      <div className="flex justify-between items-center">
        <div>
          <Search
            placeholder="Search Name / Designation / Tier"
            onSearch={onSearch}
            className="w-[280px] ml-auto"
            onChange={(e) => handleChange(e.target.value)}
          />
        </div>
        <div className="flex gap-x-[10px] p-[10px]">
          {Object.entries(annualReviewData).map((value, idx: number) => {
            if (value[0] === 'Name') return null;
            if (statusesLabel[value[0]]) {
              return (
                <div
                  key={idx}
                  style={{ background: `${statusColors[value[0]] || ''}` }}
                  className="flex flex-col rounded-[5px] text-white px-[10px] py-1"
                >
                  <div>{statusesLabel[value[0]]}</div>
                  <div className="text-base font-[500]">{`${value[1]}% Complete`}</div>
                </div>
              );
            }
            return (
              <div key={idx} className="flex flex-col px-[10px] py-1">
                <div className="opacity-50">{value[0]}</div>
                <div className="opacity-85">{value[1]}</div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="flex mb-4">
        <div className="flex gap-x-[10px]">
          <Button
            type="primary"
            onClick={handleInit}
            loading={loading}
            disabled={
              loading || disableInit || allAnnualReviewData?.status !== 0
            }
          >
            Initiate Cycle
          </Button>
          <Button
            onClick={handleClose}
            loading={loading}
            disabled={
              loading ||
              allAnnualReviewData?.status === 0 ||
              allAnnualReviewData?.status === 3
            }
          >
            Close Cycle
          </Button>
        </div>
        <div className="ml-auto">
          <Button
            icon={<DownloadOutlined />}
            onClick={handleExportData}
            loading={exportLoading}
          >
            Export to Excel
          </Button>
        </div>
      </div>

      <Table
        columns={AnnualCycleUsersColumns(annualReviewData.Name)}
        data={filtered}
        errorFetchingData={false}
        loading={fetchLoading}
        rowKey={(data) => data.userId}
      />
      {contextHolder}
      <NotificationAlert ref={myRef} />
    </div>
  );
};

export default AnnualCycleEmployees;
